import DOMPurify from 'dompurify';
import './RichContent.css';

/**
 * Renders admin-authored HTML (forum posts) after sanitizing it. Even though
 * only admins author the content, we sanitize on render as defense-in-depth.
 */
export function RichContent({ html }: { html: string }) {
  const clean = DOMPurify.sanitize(html ?? '', {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  });
  return <div className="mtc-rich" dangerouslySetInnerHTML={{ __html: clean }} />;
}
